import { OrderStatusType } from '../transaction';

export enum SecuritiesKind {
  UNSPECIFIED = 0,
  STOCK = 1,
  BOND = 2,
}

export enum OrderSecuritiesKindType {
  Unspecified = 'SECURITIES_KIND_UNSPECIFIED',
  Stock = 'SECURITIES_KIND_STOCK',
  Bond = 'SECURITIES_KIND_BOND',
}

export enum PlatformOrderTypes {
  UNSPECIFIED = 'PLATFORM_ORDER_TYPE_UNSPECIFIED',
  LIMIT = 'PLATFORM_ORDER_TYPE_LIMIT_DAY',
  FAK = 'PLATFORM_ORDER_TYPE_MARKET_FAK',
  FAST_ORDER = 'PLATFORM_ORDER_TYPE_FAST_ORDER',
}

export type PlatformOrderType =
  | PlatformOrderTypes.UNSPECIFIED
  | PlatformOrderTypes.FAST_ORDER
  | PlatformOrderTypes.LIMIT
  | PlatformOrderTypes.FAK;

export enum OrderAction {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum iOrderSide {
  UNSPECIFIED = 0,
  BUY = 1,
  SELL = 2,
}

export enum OrderSide {
  Unspecified = 'SIDE_UNSPECIFIED',
  Buy = 'SIDE_BUY',
  Sell = 'SIDE_SELL',
}

export enum OrderStatus {
  Ready = 'READY',
  Open = 'OPEN',
  Partial = 'PARTIAL',
  Rejected = 'REJECTED',
  Pending = 'PENDING',
  Active = 'ACTIVE',
  RequestAmend = 'REQUEST AMEND',
}

export enum OrderForceSellType {
  Unspecified = 'DAY_TRADE_FORCE_SELL_UNSPECIFIED',
  DebtRatio = 'DAY_TRADE_FORCE_SELL_DEBT_RATIO',
  TimeLimit = 'DAY_TRADE_FORCE_SELL_TIME_LIMIT',
}

export enum LeverageType {
  Unspecified = 'LEVERAGE_TYPE_TRADING_UNSPECIFIED',
  TradingBalance = 'LEVERAGE_TYPE_TRADING_BALANCE',
  TradingLimit = 'LEVERAGE_TYPE_TRADING_LIMIT',
  BasicLimit = 'LEVERAGE_TYPE_BASIC_LIMIT',
  TempLimit = 'LEVERAGE_TYPE_TEMP_LIMIT',
  DayTrade = 'LEVERAGE_TYPE_DAY_TRADE',
}

export const ForcedSellMapper = {
  [OrderForceSellType.DebtRatio]: 'FORCED SELL',
  [OrderForceSellType.TimeLimit]: 'FORCED SELL',
};

export enum ActionTarget {
  UNSPECIFIED = 'ACTION_TARGET_UNSPECIFIED',
  REGULAR = 'ACTION_TARGET_REGULAR',
  DAY_TRADE = 'ACTION_TARGET_DAY_TRADE',
  LEGACY_SMARTORDER = 'ACTION_TARGET_LEGACY_SMARTORDER',
  TRAILING_STOP = 'ACTION_TARGET_TRAILING_STOP',
  STOP_ORDER = 'ACTION_TARGET_STOP_ORDER',
  BRACKET_ORDER = 'ACTION_TARGET_BRACKET_ORDER',
}

export interface OrderStateItem {
  action: OrderAction;
  amend_action: boolean;
  amend_target: ActionTarget;
  amount: number;
  amount_fee: number;
  amount_invested: number;
  amount_invested_fee: number;
  amount_matched: number;
  amount_matched_broker_fee: number;
  amount_matched_exchange_fee: number;
  amount_matched_fee: number;
  amount_matched_total: number;
  amount_open: number;
  amount_open_fee: number;
  cancel_action: boolean;
  cancel_target: ActionTarget;
  config_type: string;
  currency?: string;
  gtc: number;
  gtc_text?: string;
  gtc_expired?: string;
  gtc_status?: string;
  label: string;
  market_orderid: string;
  message: string;
  order_done: number;
  order_open: number;
  order_total: number;
  orderid: string;
  price: number;
  price_average: number;
  price_average_fee: number;
  price_average_portfolio?: number;
  price_order: number;
  securities_kind: OrderSecuritiesKindType;
  smart_orderid: string;
  status: OrderStatusType;
  symbol: string;
  time: string;
  time_match: string;
  time_open: string;
  trigger_price: number;
  day_trade_is_day_trade: boolean;
  day_trade_force_sell_event: OrderForceSellType;
  day_trade_message?: string;
  leverage?: LeverageType;
  is_sharia: boolean;
  trailing_stop: SmartOrderTrailingStop;
  platform_order_type: PlatformOrderType;
}

export type OrderState = OrderStateItem[];
